export default {
	mainMenu: {
		join: 'Start',
		create: 'Start',
		admin: 'Admin',
		language: 'Sprog'
	},
	login: {
		username: 'Brugernavn',
		password: 'Kodeord',
		login: 'Log På',
		failed: 'Login mislykkedes',
		logout: 'Log ud'
	},
	intro: {
		title: 'Sådan Spiller I',
		description: 'Bla bla bla<br><br>Klik videre, og vælg en case.'
	},
	room: {
		connecting: 'Tilslutter',
		loading: 'Indlæser',
		roomCode: 'Kode',
		description: 'Scan QR-koden, eller følg linket.<br>Indtast derefter nedenstående kode for at logge ind.',
		join: 'Tilslut',
		url: 'Spiladresse',
		codeError: 'Forkert kode',
		serverError: 'Ingen forbindelse til serveren',
		connectionError: 'Kunne ikke forbinde',
		lobby: 'Lobby',
		waiting: 'Venter',
		pageType: 'Spiltype',
		unset: 'Uspecificeret',
		dilemma: 'Stem & Diskutér',
		count: 'Antal spillere logget ind:'
	},
	master: {
		selectTheme: 'Vælg et tema',
	},
	game: {
		answers: 'Stemmer modtaget',
		chooseAnswer: 'Vælg et korrekt svar',
		showAnswers: 'Stemmefordeling',
		sendMessage: 'Send Besked',
		studentWaiting: 'Kig på facilitatorens skærm'
	},
	misc: {
		back: 'Tilbage',
		cancel: 'Fortryd',
		quit: 'Afslut',
		start: 'Start',
		next: 'Næste',
		finish: 'Afslut',
		continue: 'Fortsæt',
		select: 'Vælg',
		fullScreen: 'Fuld skærm'
	}
}